// extracted by mini-css-extract-plugin
module.exports = {"componentsCaptcha":"styles_componentsCaptcha__1i1wS"};